import React, { Component } from 'react';
import Button from '../button/button';

class Frontpageblockonswerk extends Component {


    render() {
        return (
            <div className="frontpageblock--onswerk">
                <div className="frontpageblock--wrapit">
                    <h2>Ons werk</h2>
                    <p>Wat we maken, is wie we zijn.</p>
                    <Button href="/ons-werk" name="Dit is KWOOT" color="transparent" bordercolor="white" textcolor="white"/>
                </div>
            </div>
        );
    }
}

export default Frontpageblockonswerk;



// WEBPACK FOOTER //
// ./src/components/frontpageblockonswerk/frontpageblockonswerk.js